<template>
  <div style="position: relative; padding: 0px 0 30px">
    <v-premium-plan-popup
      :showAll="false"
      marginTop="65"
      v-if="$store.getters.getPackage != 'premium'"
      style="border-radius: 5px;"
      text="Upgrade to Premium, starting at 500 baht / month to view sales summary and best seller products for the further analysis. Upgrade now"
    ></v-premium-plan-popup>
    <v-container fluid>
      <div class="d-flex justify-space-between">
        <div>
          <v-btn
            v-for="app in apps"
            :key="app.value"
            small
            depressed
            :outline="selectedApp !== app.value"
            :color="selectedApp === app.value ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="onSelected(app.value)"
          >
            <i v-if="app.icon" :class="app.icon" class="mr-1"></i>
            {{ app.label }}
          </v-btn>
        </div>
        <v-btn
          outline
          color="grey"
          @click.prevent.stop="() => exportFile()"
          class="ml-auto"
          style="display: inline-block; max-width: 120px;"
        >
          <!-- @click="exportOrderSummary('separate')" -->
          <i class="fas fa-file-export mr-1"></i>
          {{ $t('export') }}
        </v-btn>
      </div>
      <date-filter
        class="my-3"
        v-model="selectedDate"
        :showTime="true"
        :default-filter="'today'"
        :itemsHide="['this_year', 'last_365_day']"
        @onSelected="date => getButtonClickAnalytics(selectedApp, date)"
      />

      <v-data-table
        class="my-3 elevation-1 scgallrenttable"
        :loading="loading"
        :headers="headers"
        :items="items"
        :hide-actions="true"
        :disable-initial-sort="true"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.action }}</td>
            <td class="text-xs-center">{{ props.item.sum_value }}</td>
            <td class="text-xs-center">{{ props.item.total_distinct_userid }}</td>
            <td class="text-xs-center">{{ props.item.count }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import XLSX from 'xlsx'
import DateFilter from './DateFilter'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      loading: false,
      selectedApp: 'all',
      selectedDate: {
        start: dayjs()
          .startOf('dates')
          .format('YYYY-MM-DD HH:mm'),
        end: dayjs()
          .endOf('dates')
          .format('YYYY-MM-DD HH:mm')
      },
      headers: [
        {
          text: this.$t('Topics'),
          value: 'action',
          align: 'left'
        },
        {
          text: this.$t('Value'),
          value: 'sum_value',
          align: 'center'
        },
        {
          text: this.$t('Total People'),
          value: 'total_distinct_userid',
          align: 'center'
        },
        {
          text: this.$t('Total Count'),
          value: 'count',
          align: 'center'
        }
      ],
      items: []
    }
  },
  mounted() {
    this.getButtonClickAnalytics(this.selectedApp, this.selectedDate)
  },
  methods: {
    async getButtonClickAnalytics(app, { start, end }) {
      this.loading = true

      try {
        const { result } = await this.get(
          `page/${this.selectedBot.pageid}/redirect-event-analytic`,
          {
            params: {
              app: app === 'all' ? undefined : app,
              start_at: start,
              end_at: end
            }
          }
        )
        this.items = result
      } catch (err) {
        console.log('err: ', err)
      } finally {
        this.loading = false
      }
    },
    onSelected(app) {
      this.selectedApp = app
      this.getButtonClickAnalytics(app, this.selectedDate)
    },
    exportFile() {
      let items = this.items
      let json = items.map(item => {
        return {
          [this.$t('Topics')]: item.action,
          [this.$t('Value')]: item.sum_value,
          [this.$t('Total People')]: item.total_distinct_userid,
          [this.$t('Total Count')]: item.count
        }
      })
      const fileName = 'url_tracking'
      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, fileName + '.xlsx')
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    apps() {
      const packages = this.selectedBot.packages
      const apps = [
        {
          label: this.$t('all'),
          value: 'all'
        }
      ]

      if (packages.includes('facebook')) {
        apps.push({
          label: this.$t('Facebook'),
          value: 'facebook',
          icon: 'fab fa-facebook-square'
        })
      }
      if (packages.includes('line')) {
        apps.push({
          label: this.$t('Line'),
          value: 'line',
          icon: 'fab fa-line'
        })
      }
      if (packages.includes('instagram')) {
        apps.push({
          label: this.$t('Instagram'),
          value: 'instagram',
          icon: 'fab fa-instagram'
        })
      }
      if (packages.includes('whatsapp')) {
        apps.push({
          label: this.$t('WhatsApp'),
          value: 'whatsapp',
          icon: 'fab fa-whatsapp'
        })
      }
      if (packages.includes('google')) {
        apps.push({
          label: this.$t('Google'),
          value: 'google',
          icon: 'fab fa-google'
        })
      }

      apps.push({
        label: this.$t('Others'),
        value: 'other'
      })

      return apps
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/analytics/ButtonClick.vue